import styled from 'styled-components';
import React from 'react';

export const PlanUsageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l);
`;

export const PlanUsageChart = styled.div<{ noIndicator?: boolean }>`
  height: var(--spacing-l);
  border-radius: var(--radius-100);
  background: var(--color-interface-layout-lighter);
  display: flex;
  align-items: center;
  width: 100%;
  padding: calc(var(--spacing-xxs) * 2) 0;
  position: relative;
  margin-top: var(--spacing-${(p) => p.noIndicator ? 'l' : 'xl'});
  margin-bottom: calc(var(--spacing-l) * 2);
`;

export const Bar = styled.div<{ width: string; color: string }>`
  position: absolute;
  height: inherit;
  border-radius: inherit;
  width: max(${(p) => p.width}, var(--spacing-l));
  background: ${(p) => p.color};
  left: 0;
`;

export const IndicatorContainer = styled.div`
  position: absolute;
  width: 100%;
  border: 2px solid var(--color-brand-purple1-normal);
  border-bottom: unset;
  height: var(--spacing-s);
  top: 0;
  margin-top: calc(var(--spacing-l) * -1);
  border-radius: 5px;
  border-bottom-left-radius: unset;
  border-bottom-right-radius: unset;
`;

export const NumberIndicator = styled.div`
  background: #ffffff;
  width: min-content;
  padding: 1px calc(var(--spacing-xxs) * 2);
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  margin: auto;
`;
